module.exports = __webpack_public_path__ + "static/fernandotitle-bff1b69f5cdbccd3730125b4881fe168.png";